import { useEffect, useState } from "react";
import logo from "../../assets/new_onboarding/Evolve_dark.webp";
import profile from "../../assets/new_onboarding/profile.png";
import ProfilePopUp from "../../components/ProfilePopUp";
import axios from "axios";
import JourneyCard from "../ProgramDashboard/JourneyCard";
import ProgramModal from "../ProgramDashboard/ProgramModal";
import useFetchProgramsSpecific from "../../hooks/useFetchProgramsSpecific";

export default function DashboardInteractive() {
  const [sidebarOpen, setSidebarOpen] = useState(false);
  const [profileOpen, setProfileOpen] = useState(false);
  const [activeTab, setActiveTab] = useState("purchases");

  // Premium flag + loading
  const [isPremium, setIsPremium] = useState(false);
  const [loadingPremium, setLoadingPremium] = useState(true);

  // Modal state
  const [selectedProgram, setSelectedProgram] = useState(null);
  const [modalOpen, setModalOpen] = useState(false);

  const journeyIds = [163, 164, 183];
  const { data: programs, errors } = useFetchProgramsSpecific(
    "https://api.evolveinc.in/api/v3/journeys/detail",
    journeyIds
  );

  // 👇 Handle when a card is clicked
  const handleCardClick = (program) => {
    setSelectedProgram(program);
    setModalOpen(true);
  };

  const closeModal = () => {
    setSelectedProgram(null);
    setModalOpen(false);
  };

  useEffect(() => {
    const fetchPremiumStatus = async () => {
      try {
        const res = await axios.get(
          `${process.env.REACT_APP_API_BASE_URL}v7/user/webflow/upgrade`,
          {
            headers: {
              Authorization: `Bearer ${localStorage.getItem("access_token")}`,
              "no-encryption": "True",
            },
          }
        );
        const data = res.data;
        setIsPremium(data.premium_status);
      } catch (err) {
        console.error("Failed to fetch premium status:", err);
      } finally {
        setLoadingPremium(false);
      }
    };

    fetchPremiumStatus();
  }, []);

  return (
    <div className="h-screen flex flex-col bg-[#FBD446]">
      {/* header */}
      <div className="bg-[#FFECAE] text-[#3F4C7C] p-4 flex justify-between">
        <img
          src={logo}
          alt="evolve logo"
          className="object-contain w-20 items-center justify-center"
        />

        <button onClick={() => setProfileOpen(!profileOpen)}>
          <img
            src={profile}
            alt="profile"
            className="object-contain w-8 bg-[#3F4C7C] rounded-full p-2"
          />
        </button>
      </div>

      <div className="flex flex-1 relative">
        {/* sidebar */}
        <div
          className={`bg-[#FFECAE] border-r transition-all duration-300 ${
            sidebarOpen ? "w-64" : "w-0"
          } overflow-hidden z-20`}
        >
          <nav className="p-4 space-y-2">
            <button
              onClick={() => setActiveTab("purchases")}
              className={`block w-full text-left p-2 rounded ${
                activeTab === "purchases" ? "bg-blue-200" : "hover:bg-gray-200"
              }`}
            >
              Your purchases
            </button>
            <button
              onClick={() => setActiveTab("explore")}
              className={`block w-full text-left p-2 rounded ${
                activeTab === "explore" ? "bg-blue-200" : "hover:bg-gray-200"
              }`}
            >
              Explore
            </button>
          </nav>
        </div>

        {/* overlay */}
        {sidebarOpen && (
          <div
            className="fixed inset-0 bg-black bg-opacity-30 z-10 transition-opacity duration-300"
            onClick={() => setSidebarOpen(false)}
          />
        )}

        {profileOpen && (
          <div className="fixed bottom-0 transition-all duration-300">
            <ProfilePopUp />
          </div>
        )}

        {/* main content */}
        {loadingPremium ? (
          <div className="self-start mt-8 ml-6 text-[#3F4C7C]">
            <p>Loading your premium status...</p>
          </div>
        ) : isPremium ? (
          <div className="grid grid-cols-2 gap-4 md:grid-cols-3 md:gap-10 self-start mt-8 ml-6">
            {programs.map((program) => (
              <JourneyCard
                key={program.id}
                program={program}
                backgroundColor={"#FFECAE"}
                onClick={() => handleCardClick(program)}
              />
            ))}
          </div>
        ) : (
          <div className="self-start mt-8 ml-6 text-[#3F4C7C]">
            <p>You need to upgrade to Premium to see these programs.</p>
          </div>
        )}

        {/* modal */}
        {modalOpen && selectedProgram && (
          <ProgramModal
            open={modalOpen}
            program={selectedProgram}
            onClose={closeModal}
          />
        )}
      </div>
    </div>
  );
}
